import CommonService from "./common.service";

const qaInspectorDashboardService = {
  getDashboard: ({ dateFrom, dateTo, module } = {}) => {
    const params = {};
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    if (module) params.module = module;
    return CommonService.get("/qa-inspector/dashboard", params);
  },
  getTabNotificationCounts: () =>
    CommonService.get("/qa-inspector/dashboard/tab-notifications", {}, { silent: true }),
};

export default qaInspectorDashboardService;
